#g-loading-animation
  #g-loading-block-1.g-loading-block
  #g-loading-block-2.g-loading-block
  #g-loading-block-3.g-loading-block
